import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../../variables";
import { toast } from "react-toastify";
import GenericBasicInfo from "../../../../../../components/cards/GenericBasicInfo";
import _ from "lodash";
import { genericRequestErrorHandler } from "../../../../../../api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteTRAVendor } from "../../../../../../api/Vendor/Trains";
import Loader from "../../../../../../components/Loader";
import { CustomButton } from "../../../../../../components/CustomButton";

const statusOptions = {
  "": "-----",
  AC: "Active",
  IN: "Inactive",
  CA: "Candidate",
};

const styles = createUseStyles({
  ...modalGenericStyles,
  DeleteTrainVendorModal: modalGenericStyles.modal,
  modalCard: {
    ...modalGenericStyles.card,
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    ...modalGenericStyles.cardBody,
    display: "grid",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: cardStyles.card,
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    gap: variables.normal_gap,
  },
});

const DeleteTrainVendorModal = ({ deletedId, data, onClose }) => {
  const classes = styles();
  const queryClient = useQueryClient();

  const DeleteTrainVendorMutation = useMutation(deleteTRAVendor, {
    onSuccess: () => {
      toast.success("Train Vendor Deleted");
      queryClient.invalidateQueries("");
      onClose();
    },
    onError: (error) => genericRequestErrorHandler(error),
  });
  const onDelete = async (id) => {
    await DeleteTrainVendorMutation.mutateAsync({ id });
  };

  const basicDataCpl = [
    ["Id", "id"],
    ["Market_type", "market_type"],
    ["Member", "member"],
    ["Notes", "notes"],
    [
      "Payment Validation",
      null,
      _.get(data, "payment_validation") === true ? "Yes" : "No" || "N/A",
    ],
    ["CXL Strategy Time", "cxl_strategy_time"],
    [
      "CXL Strategy Daysahead",
      null,
      _.get(data, "cxl_strategy_daysahead", []) === 0
        ? "0"
        : _.get(data, "cxl_strategy_daysahead"),
    ],
    ["Status", null, _.get(statusOptions, _.get(data, "status", "") || "N/A")],
  ];

  return (
    <div id="DeleteTRAVendorModal" className={classes.DeleteTrainVendorModal}>
      <React.Fragment>
        <div className={classes.modalCard}>
          {DeleteTrainVendorMutation.isLoading && <Loader onTop={true} />}
          <div className={classes.modalCardHeader}>
            <span>DELETE Train Vendor</span>
          </div>
          <div className={classes.modalCardBody}>
            <div className={classes.cardBody}>
              <GenericBasicInfo
                header={"Basic Data"}
                cardInfo={basicDataCpl}
                objectData={data}
              />
            </div>
          </div>
          <div className={classes.cardActions}>
            <CustomButton
              id="DeleteTRAVendorModalCloseButton"
              appearance="ghost"
              onClick={onClose}>
              <strong>Cancel</strong>
            </CustomButton>

            <CustomButton
              id="DeleteTRAModalConfirmButton"
              appearance="primary"
              onClick={() => {
                onDelete(deletedId);
              }}>
              <strong>DELETE</strong>
            </CustomButton>
          </div>
        </div>
      </React.Fragment>
    </div>
  );
};
DeleteTrainVendorModal.propTypes = {
  deletedId: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default DeleteTrainVendorModal;
